export default "__VITE_ASSET__qvbDJvZP__"